<script>
    import LoadingIcon from "./LoadingIcon.svelte";
    import MissingData from "./MissingData.svelte";
    import {onMount} from "svelte";
    import FreeAccessDataHiddenAlert from "./FreeAccessDataHiddenAlert.svelte";
    import {loadMoreFollows} from "../lib/ApiRequests.svelte";
    import {navigate} from "svelte-routing";
    import {_} from '../lib/i18n';

    export let analyze;


    export let params = {};
    export let date;

    let path = '';
    $: path = (params && params.path) ? params.path : '';

    let progress = 0;
    $: progress = analyze ? analyze.likesProgress : 0;

    let mounted = false;
    $: progress && mounted && initialLoad();

    onMount(async () => {
        mounted = true;
    });

    const counterIncValue = 10;

    let isLoading = false;
    async function initialLoad() {
        if (progress < 100 || isLoading || items.length > 0) return;

        isLoading = true;
        try {
            await loadMore();
            //analyze.setResults('follows', items);
        } catch (err) {
            console.error(err);
        }
        isLoading = false;
    }

    let items = [];
    $: analyze && (items = (analyze.result && analyze.result.follows)  ? analyze.result.follows : []);

    let isTemporary;
    $: isTemporary = (analyze && analyze.temporary ? true : false);

    function onImageError(event) {
        console.log(event)
        event.target.src = '/spy20-lk/icons/avatar-empty.svg';
    }

    let showCounter = 10;
    let showShowMore = false;
    $: items && (showShowMore = (items.length === showCounter));
    let isLoadingMore = false;

    let isEnabledFreeTrial = false;
    $: isEnabledFreeTrial = params.identity.isEnabledFreeTrial();

    function gotoTariffs() {
        navigate(`${path}/dashboard/subscription`);
    }

    async function loadMore() {
        isLoadingMore = true;

        if (loadMoreFollows instanceof Function) {
            try {
                const response = await loadMoreFollows(analyze.id, counterIncValue, items.length, date);
                const newItems = response.data
                showCounter += counterIncValue;
                items.push(...newItems);
                items = items;
            } catch (err) {
                console.error(err);
                isLoadingMore = false;
            }
        }

        isLoadingMore = false;
    }
</script>

{#if !isTemporary}
    {#if (((window.shared.state.language === 'en-US' && items.length > 0) || window.shared.state.language !== 'en-US') && isEnabledFreeTrial)}
        <FreeAccessDataHiddenAlert {params} />
    {/if}
    {#if items.length > 0}
        {#each items as item}
            <div class="feed-item feed-item_subscription">
                <div class="feed-item__header">
                    <div class="feed-item__header-wrapper">
                        <img src={item.photo } alt="" class="feed-item__avatar" on:error={onImageError} />
                        <div class="feed-item__info-wrapper">
                            <a href={`https://instagram.com/${item.username}`} class="feed-item__name" target="_blank">@{item.username}</a>
                            <div class="feed-item__stats-wrapper">
                                <div class="feed-item__stats-item">
                                    <div class="feed-item__stats-label">
                                        <div class="feed-item__stats-icon feed-item__stats-icon_get">
                                            <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M1.1715 1.17153L6.82835 6.82839M6.82835 6.82839L2.58571 6.82839M6.82835 6.82839L6.82835 2.58575" stroke="#1B62A4" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                        </div>
                                        <p class="feed-item__stats-title">{$_('followersResult.followEventLabel')}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        {/each}

        {#if showShowMore}
            <button class="button button_ghost feed-content__load-more-btn" on:click={loadMore} disabled={isLoadingMore}>
                <LoadingIcon show={isLoadingMore} height="16" width="16" />
                {$_('followsResult.loadMore')}
            </button>
        {/if}
    {:else}
        <MissingData {analyze} {path} analyzeInProgress={analyze && progress != 100} category="follows" />
    {/if}
{/if}

<style>
    .feed-item__avatar {
        border-radius: 100%;
    }
</style>